export default {"src":"/_next/static/media/left-arrow.0cecf6bf.svg","height":21,"width":14};